import { useContext } from "react";
import { LanguageContext } from "../app";
import { PROVIDER_DATA } from "../data/scores";
import translate from "../locales";
import clsx from "clsx";

export default function SupplierBanner() {
  const language = useContext(LanguageContext);
  const region = language === "nl" ? "nl" : "fr";

  const suppliers = PROVIDER_DATA.filter((p) => p[region] === true);

  return (
    <div className="supplier-banner">
      <p className="supplier-banner__title">
        {translate("intro.suppliers", {}, language)}
      </p>
      <div className="supplier-banner__items">
        {suppliers.map((s) => (
          <img
            src={s.logo}
            alt={s.name}
            key={s.name}
            className={clsx(
              "supplier-banner__item",
              `supplier-banner__item--${s.name}`,
            )}
          />
        ))}
      </div>
    </div>
  );
}
